import { Flex } from '@mantine/core';
import { VestingTerms } from '@dealstack/frontend/shared/components/VestingTerms/VestingTerms';
import { StyledSettingsContainer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles';

interface Props {
	organizationId: string;
}

export const ProgrammeDefaultsVestingTerms = ({ organizationId }: Props) => {
	return (
		<StyledSettingsContainer>
			<Flex direction="column" w="100%">
				<VestingTerms organizationId={organizationId} />
			</Flex>
		</StyledSettingsContainer>
	);
};
